import { Button, type ButtonProps } from '@mui/material'

function CustomButton({ children, ...restProps }: ButtonProps) {
  return (
    <Button variant="contained" disableElevation {...restProps}>
      {children}
    </Button>
  )
}
export default CustomButton
